import {useMutation, useQueryClient} from '@tanstack/react-query'

import {createAccessory, updateAccessory} from './api'
import {accessoryKeys} from './keys'
import {AccessoryRequest, AccessoryResponse} from './types'

export const useCreateAccessory = () => {
  const queryClient = useQueryClient()

  return useMutation<AccessoryResponse, unknown, AccessoryRequest>({
    mutationFn: createAccessory,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: accessoryKeys.lists()})
    },
  })
}

export const useUpdateAccessory = () => {
  const queryClient = useQueryClient()

  return useMutation<AccessoryResponse, unknown, {id: string; body: AccessoryRequest}>({
    mutationFn: ({id, body}) => updateAccessory(id, body),
    onSuccess: (_, {id}) => {
      queryClient.invalidateQueries({queryKey: accessoryKeys.detail(id)})
      queryClient.invalidateQueries({queryKey: accessoryKeys.lists()})
    },
  })
}
